var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 23,
    viewBox: "0 0 44 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 23C9.63874 22.375 0.809871 12.9985 0.427682 12.5827C-0.142561 11.9777 -0.142561 11.0223 0.427682 10.4173C0.811802 10.0013 9.63874 0.626717 21 0C15.2144 0.593139 10.6763 5.52938 10.6763 11.5C10.6763 17.4691 15.2145 22.4049 21 23Z",
    fill: "#00A9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3C17.5895 3 14 6.81357 14 11.5C14 16.1864 17.5892 20 22 20C26.4108 20 30 16.1864 30 11.5C30 6.81357 26.4108 3 22 3ZM22 14.7318C20.327 14.7318 18.9583 13.2775 18.9583 11.5C18.9583 9.72249 20.327 8.26816 22 8.26816C23.673 8.26816 25.0417 9.72249 25.0417 11.5C25.0417 13.2775 23.673 14.7318 22 14.7318Z",
    fill: "#00A9DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5723 12.5827C43.1882 12.9987 34.3613 22.3733 23 23C28.7856 22.4069 33.3237 17.4706 33.3237 11.5C33.3237 5.5309 28.7855 0.595126 23 0C34.3613 0.624985 43.1901 10.0015 43.5723 10.4173C44.1426 11.0223 44.1426 11.9777 43.5723 12.5827Z",
    fill: "#00A9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionBlueIcon);
export default __webpack_public_path__ + "static/media/visionBlueIcon.d00a6f66caa364ad328e69c76fcf2318.svg";
export { ForwardRef as ReactComponent };